export function computeMultiZone(data) {
  const zones = [
    { name: "zoneA", factor: 1.0 },
    { name: "zoneB", factor: 0.7 },
    { name: "zoneC", factor: 0.4 },
  ];

  return zones.map((zone) => {
    let score = 0;

    // ?? Core signals
    score += (data.fentanyl || 0) * 10;
    score += (data.pm25 || 0) * 0.5;
    score += (data.voc || 0) * 0.2;

    const riskScore = score * zone.factor;

    let level =
      riskScore > 80 ? "CRITICAL" :
      riskScore > 40 ? "WARNING" :
      "SAFE";

    return {
      zone: zone.name,
      riskScore: Math.round(riskScore),
      level,
    };
  });
}